const Lightbox = () => {

	const domEl = document.querySelector('#lightbox');
	if(!domEl) {
		return;
	}

	//
	// Handle closing/showing of the overlay
	const closeOverlay = (e) => {
		if(e) {
			e.preventDefault();
		}
		document.body.classList.remove('js-lightbox-revealed');

		// Tell the world
		document.dispatchEvent( new CustomEvent('LIGHTBOX_CLOSED', { detail: domEl.dataset.activeId }) );
	}

	domEl.querySelector('.lightbox-bg').addEventListener('click', closeOverlay);
	domEl.querySelector('.close-btn').addEventListener('click', closeOverlay);
};

export default Lightbox;